import { render } from "./InputRate.vue?vue&type=template&id=66201c68&scoped=true"
import script from "./InputRate.vue?vue&type=script&lang=js"
export * from "./InputRate.vue?vue&type=script&lang=js"

import "./InputRate.vue?vue&type=style&index=0&id=66201c68&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-66201c68"

export default script